var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBlocks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17652_146977)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16H0V0H16V16ZM4.86003 14.8057H7.41244V12.3034H4.86003V14.8057ZM8.58757 14.8057H11.109V12.3034H8.58757V14.8057ZM12.3034 14.8057H14.8057V12.3034H12.3034V14.8057ZM1.19434 14.8057H3.66667V12.3034H1.19434V14.8057ZM4.86003 11.109H7.41244L7.403 8.59701L4.86003 8.5931V11.109ZM9.861 8.58757C9.17458 8.58757 8.6072 8.5933 8.60026 8.60026C8.5933 8.6072 8.58757 9.17458 8.58757 9.861V11.109H11.109V8.58757H9.861ZM12.3034 11.109H14.8057V8.58757H12.3034V11.109ZM1.19434 11.109H3.66667V8.59115L1.19434 8.58757V11.109ZM1.19434 7.41244L3.66667 7.40853V4.89095H1.19434V7.41244ZM8.59701 7.403L11.109 7.41244V4.89095H8.58757L8.59701 7.403ZM12.3034 7.41244H14.8057V4.89095H12.3034V7.41244ZM4.86003 7.40658L7.403 7.403L7.41244 4.89095H4.86003V7.40658ZM1.19434 3.69661H14.8057V1.19434H1.19434V3.69661Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17652_146977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlocks);
export default __webpack_public_path__ + "static/media/icon--blocks.1778d7e8cd3619170e622aea94cc5e0a.svg";
export { ForwardRef as ReactComponent };